import React from 'react';
import { FadeIn, Button, CountdownTimer } from './Shared';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
export const FinalCTA = () => {
  return <section className="py-10 md:py-16 px-4 bg-navy-800/50 relative overflow-hidden" data-id="element-93">
      <div className="absolute inset-0 bg-gradient-to-t from-navy-900 to-transparent" data-id="element-94"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-95">
        <FadeIn data-id="element-96">
          <h2 className="text-sm font-bold tracking-widest text-red-400 uppercase mb-6" data-id="element-97">
            ⏰ EL PRECIO CIERRA EN:
          </h2>
          <div className="mb-12" data-id="element-98">
            <CountdownTimer data-id="element-99" />
          </div>

          <div className="space-y-6 max-w-2xl mx-auto mb-12" data-id="element-100">
            <div className="bg-navy-900 p-6 rounded-2xl border border-navy-700 hover:border-gold-500/30 transition-all" data-id="element-101">
              <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-102">
                <div className="text-left" data-id="element-103">
                  <h4 className="text-xl font-serif font-bold text-white" data-id="element-104">
                    📘 MEGAPACK CALMA TOTAL
                  </h4>
                  <p className="text-sm text-gray-400 mb-2" data-id="element-105">
                    6 Tomos + 4 Bonos · Niños 1 a 7 años
                  </p>
                  <div className="mt-1" data-id="element-106">
                    <span className="text-gray-500 line-through text-sm mr-2" data-id="element-107">
                      $69.000
                    </span>
                    <span className="text-2xl font-bold text-gold-400" data-id="element-108">
                      $19.990 <span className="text-sm text-gray-400" data-id="element-109">ARS</span>
                    </span>
                  </div>
                </div>
                <Button href="https://mundopractico.online/cart/48649260237017:1" className="w-full md:w-auto" data-id="element-110">
                  🟠 → QUIERO MI MEGAPACK CALMA TOTAL
                </Button>
              </div>
            </div>

            <div className="bg-gradient-to-r from-navy-800 to-navy-900 p-6 rounded-2xl border border-gold-500/50 shadow-lg shadow-gold-500/5" data-id="element-111">
              <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-112">
                <div className="text-left" data-id="element-113">
                  <h4 className="text-xl font-serif font-bold text-white" data-id="element-114">
                    🏆 MEGAPACK CALMA TOTAL + MÉTODO RAÍCES ⭐
                  </h4>
                  <p className="text-sm text-gray-400 mb-2" data-id="element-115">
                    6 Tomos + 4 Bonos + Manual de Autoestima Infantil
                  </p>
                  <div className="mt-1" data-id="element-116">
                    <span className="text-gray-500 line-through text-sm mr-2" data-id="element-117">
                      $89.000
                    </span>
                    <span className="text-2xl font-bold text-gold-400" data-id="element-118">
                      $27.990 <span className="text-sm text-gray-400" data-id="element-119">ARS</span>
                    </span>
                  </div>
                </div>
                <Button href="https://mundopractico.online/cart/48649260368089:1" className="w-full md:w-auto" data-id="element-120">
                  🟠 → QUIERO EL MEGAPACK + MÉTODO RAÍCES
                </Button>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm font-medium text-gray-400" data-id="element-121">
            <div className="flex items-center" data-id="element-122">
              <Lock className="w-4 h-4 mr-2" data-id="element-123" /> Pago 100% seguro
            </div>
            <div className="flex items-center" data-id="element-124">
              <Zap className="w-4 h-4 mr-2" data-id="element-125" /> Acceso en 5 minutos
            </div>
            <div className="flex items-center" data-id="element-126">
              <ShieldCheck className="w-4 h-4 mr-2" data-id="element-127" /> Garantía 7 días
            </div>
            <div className="flex items-center" data-id="element-128">
              <CreditCard className="w-4 h-4 mr-2" data-id="element-129" /> Mercado Pago | Tarjeta |
              Transferencia
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};